import { Plan } from '../constants/plans';

export const isPlanValueValid = (plan: unknown): plan is Plan =>
  Object.values(Plan).includes(plan as Plan);

export const isPlanParamsValid = (
  plan: Plan,
  params: {
    areaUnit: string | null;
    area: string | null;
    userSeats: string | null;
    planetImagery: string | null;
  },
) => {
  let result = false;

  if (plan === Plan.monthly) {
    result = params.areaUnit != null;
  }

  if (plan === Plan.annual) {
    result =
      params.areaUnit != null &&
      params.area != null &&
      params.userSeats != null &&
      params.planetImagery != null;
  }

  return result;
};
